/**
 * Array of menu items for user part of system.
 *
 * @type Array.<MenuItemObject>
 */
const leaderMenu = [
];

export default leaderMenu;